import type { DataValue } from 'react-apollo';
import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import type { AuthoringUserCoursePermissionsQuery } from './__generated__/AuthoringUserCoursePermissionsQuery';

type Variables = {
  courseIds?: Array<string>;
  skip?: boolean;
};
type Data = AuthoringUserCoursePermissionsQuery;

// We use an assembler resource vs. the `@naptime` directive since the information
// of a permission is encoded in the key of the `permissions` fields and not the value.
// At the time of writing, the `@naptime` directive will run the key values `_.camelCase`
// which is technically correct for graphql key naming conventions, but ruins the
// `wire format` for the permissions.
export const authoringUserCoursePermissionsQuery = gql`
  query AuthoringUserCoursePermissionsQuery($courseIds: [String!]!, $skip: Boolean! = false) {
    AuthoringUserCoursePermissionsV1Resource @skip(if: $skip) {
      multiGet(ids: $courseIds) {
        elements {
          id
          permissions
        }
      }
    }
  }
`;

export type AuthoringUserCoursePermissionsQueryProps = {
  authoringUserCoursePermissionsQuery?: {
    variables?: Variables;
    skip?: boolean;
  };
};

export type WithAuthoringUserCoursePermissionsData = {
  authoringUserCoursePermissionsData: DataValue<Data, Variables>;
};

/** @deprecated prefer useAuthoringCoursePermissions */
export const withAuthoringUserCoursePermissions = graphql<AuthoringUserCoursePermissionsQueryProps, Data, Variables>(
  authoringUserCoursePermissionsQuery,
  {
    options: ({ authoringUserCoursePermissionsQuery: { variables } = {} }) => {
      // Skip the initial query without the side-effects of the skip option, passing in skip props, etc.
      return { variables: { ...variables, skip: !variables?.courseIds?.length }, notifyOnNetworkStatusChange: true };
    },
    name: 'authoringUserCoursePermissionsData',
  }
);

export default withAuthoringUserCoursePermissions;
